/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespFollowSearchBanner_viewer$ref = any;
type SbRespMainContent_viewer$ref = any;
type SbRespNullSearchResults_viewer$ref = any;
type SbRespPriceTiles_viewer$ref = any;
type SbRespTradeOnApprovalPromoBanner_viewer$ref = any;
type SbSharedRedirectedItem_viewer$ref = any;
type SbSharedTopTileController_viewer$ref = any;
type SuspectedTradeUserLoader_viewer$ref = any;
type TradePromo_viewer$ref = any;
export type SbRespComponents_viewer$ref = any;
export type SbRespComponents_viewer = {
    readonly isBillboardAdEnabled: boolean | null;
    readonly isThinItemSearchEnabled: boolean | null;
    readonly isMoreWaysToBrowseEnabled: boolean | null;
    readonly isFollowSearchEnabled: boolean | null;
    readonly " $fragmentRefs": SbRespNullSearchResults_viewer$ref & SbRespFollowSearchBanner_viewer$ref & TradePromo_viewer$ref & SbRespPriceTiles_viewer$ref & SbRespTradeOnApprovalPromoBanner_viewer$ref & SbRespMainContent_viewer$ref & SuspectedTradeUserLoader_viewer$ref & SbSharedTopTileController_viewer$ref & SbSharedRedirectedItem_viewer$ref;
    readonly " $refType": SbRespComponents_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "kind": "Literal",
            "name": "featureName",
            "value": "NON_MVP_SEARCH_BROWSE"
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "SbRespComponents_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isTrade",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": "isBillboardAdEnabled",
                "name": "isEnabledByLocale",
                "args": (v0 /*: any*/),
                "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
            },
            {
                "kind": "ScalarField",
                "alias": "isThinItemSearchEnabled",
                "name": "isEnabledByLocale",
                "args": (v0 /*: any*/),
                "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
            },
            {
                "kind": "ScalarField",
                "alias": "isMoreWaysToBrowseEnabled",
                "name": "isEnabledByLocale",
                "args": (v0 /*: any*/),
                "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
            },
            {
                "kind": "ScalarField",
                "alias": "isFollowSearchEnabled",
                "name": "isEnabledByLocale",
                "args": (v0 /*: any*/),
                "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
            },
            {
                "kind": "FragmentSpread",
                "name": "SbRespNullSearchResults_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "SbRespFollowSearchBanner_viewer",
                "args": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isTrade",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "TradePromo_viewer",
                        "args": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "SbRespPriceTiles_viewer",
                        "args": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "SbRespTradeOnApprovalPromoBanner_viewer",
                        "args": null
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "SbRespMainContent_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "SuspectedTradeUserLoader_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "SbSharedTopTileController_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "SbSharedRedirectedItem_viewer",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = '0c684bd47a7b19e76fbb5e2e0d132663';
export default node;
